
const digest = '4033163f5896340f1d32826472b70152e103d2884250e8b9e8b5cdaf5f5dc509';
const classes = {"wrapper":"_wrapper_h08g3_1","leftSide":"_leftSide_h08g3_8","image":"_image_h08g3_17","content":"_content_h08g3_23","name":"_name_h08g3_28","text":"_text_h08g3_33","rightSide":"_rightSide_h08g3_38","title":"_title_h08g3_47","row":"_row_h08g3_52","item":"_item_h08g3_57","badgeWrapper":"_badgeWrapper_h08g3_65"};
const css = `._wrapper_h08g3_1 {
  display: flex;
  flex-direction: row;
  background-color: #ffffff;
  border: 1px solid #aeb8cb;
  border-radius: 5px;
}
._wrapper_h08g3_1 ._leftSide_h08g3_8 {
  padding: 24px;
  display: flex;
  flex-direction: row;
  min-width: 360px;
  max-width: 360px;
  gap: 15px;
  align-items: center;
}
._wrapper_h08g3_1 ._leftSide_h08g3_8 ._image_h08g3_17 img {
  width: 75px;
  height: 75px;
  border-radius: 100%;
  object-fit: cover;
}
._wrapper_h08g3_1 ._leftSide_h08g3_8 ._content_h08g3_23 {
  display: flex;
  flex-direction: column;
  gap: 5px;
}
._wrapper_h08g3_1 ._leftSide_h08g3_8 ._content_h08g3_23 ._name_h08g3_28 {
  font-size: 16px;
  font-weight: 600;
  text-decoration: underline;
}
._wrapper_h08g3_1 ._leftSide_h08g3_8 ._content_h08g3_23 ._text_h08g3_33 {
  font-size: 14px;
  color: #787c88;
  font-weight: 400;
}
._wrapper_h08g3_1 ._rightSide_h08g3_38 {
  padding: 24px;
  flex-grow: 1;
  border-left: #aeb8cb 1px solid;
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 5px;
}
._wrapper_h08g3_1 ._rightSide_h08g3_38 ._title_h08g3_47 {
  color: #000;
  font-size: 14px;
  font-weight: 500;
}
._wrapper_h08g3_1 ._rightSide_h08g3_38 ._row_h08g3_52 {
  display: flex;
  flex-direction: row;
  gap: 20px;
}
._wrapper_h08g3_1 ._rightSide_h08g3_38 ._item_h08g3_57 {
  color: #9ea0a5;
  font-size: 14px;
  font-weight: 400;
}
._wrapper_h08g3_1 ._rightSide_h08g3_38 ._item_h08g3_57 span {
  color: #3e3f42;
}
._wrapper_h08g3_1 ._rightSide_h08g3_38 ._badgeWrapper_h08g3_65 {
  position: absolute;
  right: 24px;
  display: flex;
  flex-direction: column;
  gap: 5px;
  align-items: flex-end;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  